export interface ViewspecState {
  /** Depth limit: null = show all, 1 = top level only, etc. */
  depthLimit: number | null;
  /** Content display mode */
  showContent: "all" | "first-line" | "none";
  /** Show hierarchical statement IDs */
  showSIDs: boolean;
  /** Show blank lines between statements */
  showBlankLines: boolean;
  /** Freeze view on a statement SID (zoom) */
  showFrozen: string | null;
  /** Filter: only show statements containing this text */
  filterText: string | null;
  /** Indent statements by depth level */
  indentation: boolean;
  /** Numbering mode */
  numbering: "sid" | "sequential" | "none";
  /** Split screen mode */
  splitMode: "none" | "horizontal" | "vertical";
  /** Link split panes (scroll together) */
  splitLinked: boolean;
}

export const DEFAULT_VIEWSPECS: ViewspecState = {
  depthLimit: null,
  showContent: "all",
  showSIDs: true,
  showBlankLines: false,
  showFrozen: null,
  filterText: null,
  indentation: true,
  numbering: "sid",
  splitMode: "none",
  splitLinked: false,
};
